
/* eslint-disable */
import {
  TOGGLE_COLLAPSED_NAV, 
  INCREMENT_PLANSLIST_GRID, 
  INCREMENT_PROJECTSLIST_GRID, 
  INCREMENT_CAPITALPLAN_LIST, 
  INCREMENT_PROJECTTRACKERLIST_GRID,
  INCREMENT_ESTIMATORLIST_GRID,
  INCREMENT_MIGRATION_LIST,
  CLEAR_COMMON_ALERT,
  SET_COMMON_ALERT,
  UPDATE_DRAFT_ALERT,
} from '../constants/ActionTypes';
import { SET_TRIGGER_SOURCE, START_GLOBAL_LOADING, STOP_GLOBAL_LOADING } from '../constants/Common';

const initialSettings = {
  navCollapsed: false,
  globalLoading: false,
  alerts:{},
  draftInstrumentCount: 0,
  triggerSource: {key: "", ts: Date.now()},
};

const commonReducer = (state = initialSettings, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        navCollapsed: false,
      };
    case START_GLOBAL_LOADING:
      return {
        ...state,
        globalLoading: true,
      };
    case STOP_GLOBAL_LOADING:
      return {
        ...state,
        globalLoading: false,
      };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: !state.navCollapsed,
      };

    case CLEAR_COMMON_ALERT:
      return {
        ...state,
        alerts: {},
      };
    case SET_COMMON_ALERT:
      return {
        ...state,
        alerts:action.payload
      };
    case UPDATE_DRAFT_ALERT:
      return {
        ...state,
        draftInstrumentCount:action.payload
      }
    case SET_TRIGGER_SOURCE:
      return {
        ...state,
        triggerSource: action.payload,
      };
   
    default:
      return state;
  }
};

export default commonReducer;
